import TechPriceChart from './TechPriceChart';

export default TechPriceChart;
